export default "__VITE_ASSET__BZMc0CvR__"